import { INTELLIGENT_PHOTO_CAPTURE_GET_DOWNLOAD_AUTH_DETAILS_DATA_REQUEST, INTELLIGENT_PHOTO_CAPTURE_GET_DOWNLOAD_AUTH_DETAILS_DATA_SUCCESS } from '../actions';
export const photoCaptureIntelligentDownloadAuthDetailsReducer = (state, action) => {
    const downloadAuthResponse = action.payload.photoCaptureDownloadAuthenticationData;
    switch (action.type) {
        case INTELLIGENT_PHOTO_CAPTURE_GET_DOWNLOAD_AUTH_DETAILS_DATA_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true, companyCode: action.payload.coCode, contextId: action.payload.contextId });
        case INTELLIGENT_PHOTO_CAPTURE_GET_DOWNLOAD_AUTH_DETAILS_DATA_SUCCESS:
            return Object.assign(Object.assign({}, state), { isLoading: false, authToken: downloadAuthResponse.authToken, workItemStatus: downloadAuthResponse.taskStatus, downloadArtifactAuthDetailsInfo: {
                    downloadAllowed: downloadAuthResponse.downloadAllowed,
                    downloadLinkExpired: downloadAuthResponse.downloadLinkExpired,
                    reactivateAllowed: downloadAuthResponse.reactivateAllowed
                } });
        default:
            return state;
    }
};
//# sourceMappingURL=photoCaptureIntelligentDownloadAuthDetailsReducer.js.map